import { notice } from './index'

// 공통 필터 메서드 적용 
import { checkLimitedUser } from './function/method'

function fetchNoticeList(option) {
  return notice.post('list.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

function fetchNoticeDetail(option) {
  return notice.post('detail.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

function fetchFAQList(option) {
  return notice.post('faq.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

function fetchFAQCategoryList(option) {
  return notice.post('faqTabList.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

function fetchTermsList() {
  return notice.post('termsList.do', {})
  .then((res) => {
    return checkLimitedUser(res)
  });
}

function fetchTermsDetail(option) {
  return notice.post('termsDetail.do', option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

export { fetchNoticeList, fetchNoticeDetail, fetchFAQList, fetchFAQCategoryList, fetchTermsList, fetchTermsDetail }